import { gql } from "@apollo/client";
import { apolloClient } from "../index";
import {
  ImageFolderProps,
  SelectItemProps,
  ImageDesc,
} from "../types/globals.types";

export const getImageFoldersTree = async () => {
  const getImageFolderContent = async (
    folderId?: string
  ): Promise<ImageFolderProps> => {
    const query = gql`
    query {
      ${
        !folderId?.length
          ? `imagesFolders(filters: { name: { eq: "root" } })`
          : `imagesFolder(id:"${folderId}")`
      } {
        data {
          id
          attributes {
            name
            sub_folders {
              data {
                id
              }
            }
            images {
              data {
                attributes {
                  name
                  url
                  formats
                }
              }
            }
          }
        }
      }
    }
  `;
    try {
      const { error, data } = await apolloClient.query({ query });
      if (error) throw error;

      //else
      //If root

      const _data = folderId
        ? data?.imagesFolder?.data
        : data?.imagesFolders?.data[0];

      if (_data) {
        const result: ImageFolderProps = {
          id: _data.id,
          name: _data.attributes?.name,
          images: _data.attributes?.images?.data?.map((x: any) => ({
            url: x.attributes?.url,
            thumbnail:
              x.attributes?.formats?.thumbnail?.url ?? x.attributes?.url,
          })),
          subFolders: await Promise.all(
            _data.attributes?.sub_folders?.data?.map((x: any) =>
              getImageFolderContent(x.id)
            )
          ),
        };
        return result;
      }
      throw new Error("The image folder does not exists!");
    } catch (error) {
      throw error;
    }
  };
  function fillCount(root: ImageFolderProps) {
    // Use a stack to perform a depth-first traversal (DFS)
    const stack = [root];

    // First pass to find all nodes in post-order (from leaves to root)
    const postOrder = [];

    // Continue exploring as long as there are nodes in the stack
    while (stack.length > 0) {
      const node = stack.pop();

      // Add the node to the post-order traversal
      postOrder.push(node);

      // Add subfolders to the stack to keep exploring
      if (node?.subFolders?.length) {
        stack.push(...node.subFolders);
      }
    }

    // Process nodes in reverse order to fill the `count` fields
    for (let i = postOrder.length - 1; i >= 0; i--) {
      const node = postOrder[i];
      if (node) {
        // Calculate the number of images under this node
        let count = node?.images?.length ?? 0;

        // Add images from subfolders
        if (node?.subFolders?.length) {
          node.subFolders.forEach((x: any) => {
            count += x.count;
          });
        }

        // Fill the count field for this node
        node.count = count;
      }
    }
  }
  function activeFirstNode(curr: ImageFolderProps): ImageDesc[] | undefined {
    curr.active = true;
    if (!curr.images?.length && curr.subFolders?.length) {
      return activeFirstNode(curr.subFolders[0]);
    } else {
      return curr.images;
    }
  }
  function addParents(curr: ImageFolderProps, parent?: ImageFolderProps) {
    curr.parent = parent;
    if (curr.subFolders?.length) {
      curr.subFolders.forEach((x) => addParents(x, curr));
    }
  }
  const tree = await getImageFolderContent();
  fillCount(tree);
  const activeImages = activeFirstNode(tree);
  addParents(tree);
  return { tree, activeImages };
};

export const getWorksetups = async (): Promise<SelectItemProps[]> => {
  const query = gql`
    query {
      worksetups {
        data {
          id
          attributes {
            name
          }
        }
      }
    }
  `;
  try {
    const { error, data } = await apolloClient.query({ query });
    if (error) throw error;

    //else
    const _data = data?.worksetups?.data;
    const result = _data?.map((x: any) => {
      return {
        label: x.attributes?.name,
        value: x.id,
      };
    });

    return result;
  } catch (error) {
    throw error;
  }
};

export const getSeniorities = async (): Promise<SelectItemProps[]> => {
  const query = gql`
    query {
      seniorities(sort: "order:asc") {
        data {
          id
          attributes {
            name
          }
        }
      }
    }
  `;
  try {
    const { error, data } = await apolloClient.query({ query });
    if (error) throw error;

    //else
    const _data = data?.seniorities?.data;
    const result = _data?.map((x: any) => {
      return {
        label: x.attributes?.name,
        value: x.id,
      };
    });

    return result;
  } catch (error) {
    throw error;
  }
};

export const getLocations = async (): Promise<SelectItemProps[]> => {
  const query = gql`
    query {
      locations(sort: "name:asc") {
        data {
          id
          attributes {
            name
          }
        }
      }
    }
  `;
  try {
    const { error, data } = await apolloClient.query({ query });
    if (error) throw error;

    //else
    const _data = data?.locations?.data;
    const result = _data?.map((x: any) => {
      return {
        label: x.attributes?.name,
        value: x.id,
      };
    });

    return result;
  } catch (error) {
    throw error;
  }
};

export const getCategories = async (): Promise<SelectItemProps[]> => {
  const query = gql`
    query {
      categories {
        data {
          id
          attributes {
            name
          }
        }
      }
    }
  `;
  try {
    const { error, data } = await apolloClient.query({ query });
    if (error) throw error;

    //else
    const _data = data?.categories?.data;
    const result = _data?.map((x: any) => {
      return {
        label: x.attributes?.name,
        value: x.id,
      };
    });

    return result;
  } catch (error) {
    throw error;
  }
};
